import Vue from "vue";
import VueRouter from "vue-router";
import DefaultLayout from "../layouts/DefaultLayout.vue";

// 页面组件

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: DefaultLayout, // 使用布局组件包裹页面
    children: [
      {
        path: "",
        name: "Home",
        component: () => import("@/views/Home.vue"),
        meta: {
          title: "首页",
          showNav: true,
          showTabbar: true,
        },
      },
      {
        path: "/game",
        name: "game",
        component: () => import("@/views/Game.vue"),
        meta: {
          title: "游戏产品",
          showNav: true,
          showTabbar: true,
        },
      },
      {
        path: "/about",
        name: "about",
        component: () => import("@/views/About.vue"),
        meta: {
          title: "关于",
          showNav: true,
          showTabbar: true,
        },
      },
      {
        path: "/Creative",
        name: "Creative",
        component: () => import("@/views/Creative.vue"),
        meta: {
          title: "合作共创",
          showNav: true,
          showTabbar: true,
        },
      },

      {
        path: "/new",
        name: "new",
        component: () => import("@/views/New.vue"),
        meta: {
          title: "新闻公告",
          showNav: true,
          showTabbar: true,
        },
      },
      {
        path: "/gameplay",
        name: "gameplay",
        component: () => import("@/views/Gameplay.vue"),
        meta: {
          title: "玩家服务",
          showNav: true,
          showTabbar: true,
        },
      },
      {
        path: "/join",
        name: "join",
        component: () => import("@/views/Join.vue"),
        meta: {
          title: "加入我们",
          showNav: true,
          showTabbar: true,
        },
      },
      {
        path: "/joininfo",
        name: "joininfo",
        component: () => import("@/views/joinInfo.vue"),
        meta: {
          title: "加入我们",
          showNav: true,
          showTabbar: true,
        },
      },
      {
        path: "/joinlist",
        name: "joinlist",
        component: () => import("@/views/joinlist.vue"),
        meta: {
          title: "加入我们",
          showNav: true,
          showTabbar: true,
        },
      },
      {
        path: "/news",
        name: "news",
        component: () => import("@/views/News.vue"),
        meta: {
          title: "新闻公告",
          showNav: true,
          showTabbar: true,
        },
      },
    ],
  },
  {
    path: "/addiction",
    name: "addiction",
    component: () => import("@/views/addiction.vue"),
  },
  {
    path: "/GrowingCare",
    name: "GrowingCare",
    component: () => import("@/views/GrowingCare.vue"),
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("@/views/privacy.vue"),
  },
  {
    path: "/reporting",
    name: "reporting",
    component: () => import("@/views/reporting.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { x: 0, y: 0 };
  },
});

export default router;
